import React from 'react'

import { LineItemTotals } from '../../../models/line-item'
import { useRegisterManager } from '../../../ng-compat/hooks'
import { useFormatNumber } from '../../helpers/formatNumberHooks'

interface Props {
  totals: LineItemTotals
}

export const LineItemTotalPrice: React.FC<Props> = ({ totals }) => {
  const formatNumber = useFormatNumber()
  const registerManager = useRegisterManager()

  const totalPrice = registerManager.isTaxInclusive()
    ? totals.inclusivePrice
    : totals.exclusivePrice

  return (
    <span className="wr-li-cell-summary-price-value vd-text-label">
      {formatNumber(totalPrice)}
    </span>
  )
}
